import { ENV } from '../config/env';

const getToken = () => localStorage.getItem('auth_token');

export const DevelopmentUploadsService = {
  async uploadImage(developmentId: number | string, file: File) {
    const url = `${ENV.API_URL}/admin/developments/${developmentId}/images/upload`;
    const token = getToken();
    const form = new FormData();
    form.append('file', file);

    const res = await fetch(url, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(text || 'Error subiendo imagen');
    }
    return res.json();
  },

  async uploadDocument(
    developmentId: number | string,
    file: File,
    payload?: { title?: string }
  ) {
    const url = `${ENV.API_URL}/admin/developments/${developmentId}/documents/upload`;
    const token = getToken();
    const form = new FormData();
    form.append('file', file);
    if (payload?.title) form.append('title', payload.title);

    const res = await fetch(url, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(text || 'Error subiendo PDF');
    }
    return res.json();
  }
};
